import React from 'react';
import { Box, LinearProgress, Typography, useMediaQuery } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';

const PasswordStrengthBar = ({ password }) => {
  const esMovil = useMediaQuery('(max-width:767px)');
  const { t } = useTranslation();

  const calculateStrength = (password) => {
    let score = 0;

    const hasNumber = /\d/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (hasNumber) score++;
    if (hasUpperCase) score++;
    if (hasSymbol) score++;

    if (password.length >= 8) score++;

    return score;
  };

  const strength = calculateStrength(password);

  const getColor = () => {
    switch (true) {
      case strength === 1:
        return 'red';
      case strength === 2:
        return 'orange';
      case strength >= 3:
        return 'green';
      default:
        return 'gray';
    }
  };

  const getSecurityLevelKey = () => {
    switch (true) {
      case strength === 1:
        return 'low';
      case strength === 2:
        return 'medium';
      case strength >= 3:
        return 'high';
      default:
        return 'default';
    }
  };

  const color = getColor();
  const securityLevel = getSecurityLevelKey(); // This will be 'low', 'medium', or 'high'

  return (
    <Box sx={{  display: esMovil ? 'inline-block' : 'flex', alignItems: 'center', marginTop: '10px', width: '100%' }}>
      <Typography sx={{ fontSize: 12, color, marginRight: '10px', display: 'flex', flexDirection: 'row', 
        ...(esMovil && {
          display: 'block',
          marginTop: '5px',
          marginBottom: '5px',
          textAlign: 'center'
        }), }}>
        <Box style={{fontSize: 12, marginRight: '5px', color: '#64748B'}}>{t('signUp.passwordSecurity')}
          <Trans i18nKey={`signUp.security.${securityLevel}`}></Trans>
        </Box>
      </Typography>
      <Box sx={{ width: '60%', display: 'flex', justifyContent: 'space-between', textAlign: esMovil ? 'center' : '', width: esMovil ? '100%' : '250px' }}>
        {[1, 2, 3].map((bar) => {
        let barColor;
        if (bar === 1) barColor = '#FF4D4D'; // Red for the first bar
        if (bar === 2) barColor = '#FFA500'; // Orange for the second bar
        if (bar === 3) barColor = '#00C851'; // Green for the third bar

        return (
            <LinearProgress
            key={bar}
            variant="determinate"
            value={strength >= bar ? 100 : 0}
            sx={{
                width: '30%',
                height: '8px',
                bgcolor: '#e0e0e0',
                '& .MuiLinearProgress-bar': {
                backgroundColor: strength >= bar ? barColor : '#e0e0e0',
                },
            }}
            />
        );
        })}
      </Box>
    </Box>
  );
};

export default PasswordStrengthBar;
